import { Icon, IconProps } from './Icon';

export type AudioProps = IconProps;

export const Audio = (props: AudioProps) => (
  <Icon width="16px" height="16px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M6 12V4.237c0-.321 0-.482.058-.612a.667.667 0 0 1 .24-.282c.118-.079.277-.105.593-.158l5.867-.978c.427-.071.64-.107.808-.045a.666.666 0 0 1 .346.293c.088.154.088.371.088.804v7.408M6 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm8-1.333a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
